import type { FC } from 'react';
import { useTheme } from 'styled-components';
import type { IIconsProps } from './types';
import { IconScale } from './types';

const Document: FC<IIconsProps> = ({
  color,
  size = IconScale.S,
}: IIconsProps) => {
  const theme = useTheme();
  if (!color) {
    color = theme.palette.primary.main;
  }
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.33325 13.9998H10.6666C11.7712 13.9998 12.6666 13.1044 12.6666 11.9998V7.65733C12.6666 7.13463 12.4619 6.63269 12.0965 6.25898L10.6249 4.75422L9.17163 3.26815C8.79535 2.88339 8.2799 2.6665 7.74173 2.6665H5.33325C4.22868 2.6665 3.33325 3.56193 3.33325 4.6665V11.9998C3.33325 13.1044 4.22868 13.9998 5.33325 13.9998Z"
        stroke={color}
        strokeWidth="1.5"
      />
      <path
        d="M8 2.6665V6.33317C8 6.88546 8.44772 7.33317 9 7.33317H12.6667"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
};

export default Document;
